import PdfAttach from "../../PageComponents/PdfAttach/PdfAttach";
import FormLabel from "../FormLabel/FormLabel";

const AttachAdditionalDocumentation = ({
  onFilesSelect,
  totalFiles,
  maxFiles,
}) => {
  const storageKey = "additionalDocumentationFiles";
  return (
    <div style={{ marginBottom: "20px" }}>
      <FormLabel
        label={
          "Ukoliko postoji dodatna dokumentacija o projektu(prijavni obrazac,\
        Tablica proračuna, i sl.) možete je priložiti"
        }
      />
      <PdfAttach
        onFilesSelect={onFilesSelect}
        storageKey={storageKey}
        totalFiles={totalFiles}
        maxFiles={maxFiles}
      />
    </div>
  );
};

export default AttachAdditionalDocumentation;
